import { render, staticRenderFns } from "./p_tech012.vue?vue&type=template&id=b5c9a35e&scoped=true&"
import script from "./p_tech012.vue?vue&type=script&lang=js&"
export * from "./p_tech012.vue?vue&type=script&lang=js&"
import style0 from "./p_tech012.vue?vue&type=style&index=0&id=b5c9a35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c9a35e",
  null
  
)

export default component.exports